<template>
  <custom-dialog width="1000px" :title="model.title" class="productCode-item-dialog" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body" ref="body">
      <div class="product-info">
        <el-form :model="form" ref="form" class="form-section">
          <el-form-item :label="$t('dms_productCode_item_dialog.chan_pin_xing_hao')" prop="productCode" :rules="rules.productCode">
            <el-input v-model="form.productCode" :disabled="Boolean(form.productCodeId)"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dms_productCode_item_dialog.ISTzhan_dian')" prop="websiteCode" :rules="rules.websiteCode">
            <custom-select
              v-model="form.websiteCode"
              url="websiteSelectList"
              :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
              :props="{ label: 'websiteName', value: 'websiteCode' }"
              @change="onChangeWebsiteName"
              width="100%"
            ></custom-select>
          </el-form-item>
          <!-- 系统管理员的品牌排在这里 -->
          <el-form-item :label="$t('dms_productCode_item_dialog.pin_pai')" prop="productBrand" :rules="rules.productBrand">
            <custom-select code="iot_product_brand" isDefault v-model="form.productBrand" width="100%"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_productCode_item_dialog.chan_pin_lei_bie')" prop="productClass" :rules="rules.productClass">
            <custom-select code="dms_product_class" v-model="form.productClass" width="100%"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_productCode_item_dialog.chan_pin_lei_xing')" prop="productType" :rules="rules.productType">
            <custom-select code="dms_product_type" v-model="form.productType" width="100%"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_productCode_item_dialog.er_ji_lei_xing')" prop="productSubType" :rules="rules.productSubType">
            <custom-select code="dms_product_sub_type" v-model="form.productSubType" width="100%"></custom-select>
          </el-form-item>
          <el-form-item :label="$t('dms_productCode_item_dialog.shun_xu_pai_xu')" prop="showOrder">
            <el-input v-model.number="form.showOrder"></el-input>
          </el-form-item>
          <el-form-item :label="$t('Common.com_status')" prop="state" :rules="rules.state">
            <custom-select code="cloud_valid_invalid_state" v-model="form.state" isDefault width="100%"></custom-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="product-r">
        <div class="product-doc">
          <div class="title">{{ $t('dms_productCode_item_dialog.chan_pin_wen_dang') }}</div>
          <t-upload ref="productFile" :limit="4" type="file" :bizId="productCodeId" bizType="dms.product.doc" v-model="instructionsList" :tip="$t('dms_productCode_item_dialog.zcdgwj2Myn')" :autoUpload="false"></t-upload>
        </div>
        <div class="product-img">
          <div class="title">{{ $t('dms_productCode_item_dialog.chan_pin_zhu_tu') }}</div>
          <t-upload ref="productMainImage" :bizId="productCodeId" bizType="dms.product.icon" v-model="productIconList" type="text" :autoUpload="false"></t-upload>
        </div>
        <div class="product-img">
          <div class="title">{{ $t('dms_productCode_item_dialog.chan_pin_hua_ce') }}</div>
          <t-upload ref="productImage" :limit="4" :bizId="productCodeId" bizType="dms.product.atlas" v-model="picList" :autoUpload="false"></t-upload>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('Common.com_cancel') }}
      </el-button>
      <el-button type="primary" @click="onConfirm">
        {{ $t('Common.com_confirm') }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 产品型号编辑/新增 弹窗 */
import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  components: {
    tUpload,
  },
  data() {
    return {
      productCodeId: '',
      productCode: '',
      form: {
        productCodeId: '',
        productCode: '',
        websiteCode: '',
        websiteName: '',
        productBrand: '',
        productClass: '',
        productType: '',
        productSubType: '',
        showOrder: 0,
        state: '',
      },
      instructionsList: [],
      picList: [],
      productIconList: [],
    };
  },

  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        productCode: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 20, min: 0, message: this.$t('Common.com_rules_length_max', [20]) },
        ],
        productBrand: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required'),
        },
        productClass: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 20, min: 0, message: this.$t('Common.com_rules_length_max', [20]) },
        ],
        productType: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 20, min: 0, message: this.$t('Common.com_rules_length_max', [20]) },
        ],
        productSubType: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 20, min: 0, message: this.$t('Common.com_rules_length_max', [20]) },
        ],
        websiteCode: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required'),
        },
        showOrder: {
          type: 'number',
          required: true,
          message: this.$t('Common.com_required'),
        },
        state: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  methods: {
    initDialog() {
      if (this.model.type === 'edit') {
        this.productCodeId = this.model.productCodeId;
        this.form.productCodeId = this.model.productCodeId;
        // this.productCode = this.model.productCode;
        // this.form.productCode = this.model.productCode;
        this.getProductDetail();
      }
    },
    // 获取产品详情
    getProductDetail: function () {
      if (this.productCodeId) {
        this.$getJSON(apis.productCodeInfo, {
          productCodeId: this.productCodeId,
        }).then((res) => {
          const data = res.data;
          this.$setFormatData(this.form, data);
        });
      }
    },
    onChangeWebsiteName(item) {
      if (item) {
        this.form.websiteName = item.websiteName;
      }
    },
    getCreateReqData() {
      const ret = {
        ...this.form,
        instructionsList: this.instructionsList,
        picList: this.picList,
        productIconList: this.productIconList,
      };
      return ret;
    },
    getEditReqData() {
      return {
        ...this.getCreateReqData(),
      };
    },
    create() {
      return this.$postJSON(apis.productCodeAdd, this.getCreateReqData());
    },
    save() {
      return this.$postJSON(apis.productCodeUpdate, this.getEditReqData());
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    async onConfirm() {
      this.$refs.form.validate(async (val) => {
        if (val) {
          const submitArr = [this.$refs.productFile.submit(), this.$refs.productMainImage.submit(), this.$refs.productImage.submit()];
          await Promise.all(submitArr);
          if (this.productCodeId) {
            await this.save();
            this.$emit('success');
            this.closeDialog();
          } else {
            await this.create();
            this.$emit('success');
            this.closeDialog();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.productCode-item-dialog {
  .dialog-body {
    display: flex;

    .product-info {
      width: 420px;

      .form-section {
        .el-form-item__label {
          color: #495057 !important;
          font-weight: bold;
          width: 100%;
          text-align: left;
        }

        .el-textarea__inner {
          height: 63px !important;
        }
      }

      .copy {
        float: right;
      }
    }

    .product-r {
      padding-left: 24px;
      width: 355px;
      border-left: 1px solid #f2f3fb;
      margin-left: 24px;
      .title {
        line-height: 28px;
        color: #495057;
        font-size: 12px;
        font-weight: bold;
      }
    }

    .product-img {
      margin-top: 24px;
    }
  }
}
</style>
